import { render, staticRenderFns } from "./TeacherAttendance.vue?vue&type=template&id=5a29ad4c&lang=en&"
import script from "./TeacherAttendance.vue?vue&type=script&lang=js&"
export * from "./TeacherAttendance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports